import React from 'react';
import { datadogRum } from '@datadog/browser-rum';

interface ErrorBoundaryProps {
  children?: React.ReactNode;
  fallback: React.ReactElement<{ error?: Error }>;
}

interface ErrorBoundaryState {
  error: Error | null;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    datadogRum.addError(error, info);
  }

  render() {
    const { error } = this.state;
    const { children, fallback } = this.props;

    if (!error) {
      return children;
    }

    return React.cloneElement(fallback, { error });
  }
}

export default ErrorBoundary;
